class Four04Controller {
    constructor(translationService) {
        Object.assign(this, { translationService });
    }
}

Four04Controller.$inject = ['translationService'];

export default Four04Controller;
